import { DefaultState, DropdownItem } from 'store/types';
import { AutomatedReportForm } from '../post-automated-report/types';

export const GET_AUTOMATED_REPORT_REQUEST = 'GET_AUTOMATED_REPORT_REQUEST';
export const GET_AUTOMATED_REPORT_SUCCESS = 'GET_AUTOMATED_REPORT_SUCCESS';
export const GET_AUTOMATED_REPORT_FAILURE = 'GET_AUTOMATED_REPORT_FAILURE';
export const GET_AUTOMATED_REPORT_CLEAR = 'GET_AUTOMATED_REPORT_CLEAR';

export interface AutomatedReportFormData extends AutomatedReportForm {
  reportTypesSelectList: DropdownItem[];
  reportDatesSelectList: DropdownItem[];
  weekDaysSelectList: DropdownItem[];
  userEmailsSelectList: DropdownItem[];
}

export type GetAutomatedReportState = DefaultState & {
  contents?: AutomatedReportFormData;
};

interface GetAutomatedReportRequest {
  type: typeof GET_AUTOMATED_REPORT_REQUEST;
}

interface GetAutomatedReportSuccess {
  type: typeof GET_AUTOMATED_REPORT_SUCCESS;
  contents: AutomatedReportFormData;
}

interface GetAutomatedReportFailure {
  type: typeof GET_AUTOMATED_REPORT_FAILURE;
}

interface GetAutomatedReportClear {
  type: typeof GET_AUTOMATED_REPORT_CLEAR;
}

export type GetAutomatedReportActionTypes = GetAutomatedReportRequest | GetAutomatedReportSuccess | GetAutomatedReportFailure | GetAutomatedReportClear;